import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE = '/api/v1/public/book';

const methodIcons = {
  google_meet: '📹 Google Meet',
  zoom: '💻 Zoom',
  phone: '📞 مكالمة هاتفية',
  in_person: '🏢 حضوري'
};

function PublicBooking() {
  var params = useParams();
  var agentSlug = params.agentSlug;
  var eventSlug = params.eventSlug;

  var _lang = useState('en');
  var lang = _lang[0]; var setLang = _lang[1];
  var _step = useState(1);
  var step = _step[0]; var setStep = _step[1];
  var _loading = useState(true);
  var loading = _loading[0]; var setLoading = _loading[1];
  var _eventData = useState(null);
  var eventData = _eventData[0]; var setEventData = _eventData[1];
  var _agentData = useState(null);
  var agentData = _agentData[0]; var setAgentData = _agentData[1];
  var _error = useState('');
  var errorMsg = _error[0]; var setError = _error[1];
  var _selectedDate = useState('');
  var selectedDate = _selectedDate[0]; var setSelectedDate = _selectedDate[1];
  var _slots = useState([]);
  var slots = _slots[0]; var setSlots = _slots[1];
  var _slotsLoading = useState(false);
  var slotsLoading = _slotsLoading[0]; var setSlotsLoading = _slotsLoading[1];
  var _selectedSlot = useState(null);
  var selectedSlot = _selectedSlot[0]; var setSelectedSlot = _selectedSlot[1];
  var _name = useState('');
  var custName = _name[0]; var setCustName = _name[1];
  var _phone = useState('');
  var custPhone = _phone[0]; var setCustPhone = _phone[1];
  var _email = useState('');
  var custEmail = _email[0]; var setCustEmail = _email[1];
  var _method = useState('');
  var connMethod = _method[0]; var setConnMethod = _method[1];
  var _reason = useState('');
  var meetReason = _reason[0]; var setMeetReason = _reason[1];
  var _submitting = useState(false);
  var submitting = _submitting[0]; var setSubmitting = _submitting[1];
  var _result = useState(null);
  var bookingResult = _result[0]; var setBookingResult = _result[1];

  var isRTL = lang === 'ar';

  // ─── Inject dark styles + fonts ───────────────────────────────────────────
useEffect(function() {
    var link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Cairo:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    var s = document.createElement('style');
    s.id = 'pb-dark-override';
    s.textContent = [
      '[data-theme="light"] #pb-root .pb-bio-text, [data-theme="light"] #pb-root .pb-bio-section, [data-theme="light"] #pb-root .pb-bio-label { background-color: transparent !important; }',
'[data-theme="light"] #pb-root div, [data-theme="light"] #pb-root span, [data-theme="light"] #pb-root p, [data-theme="light"] #pb-root label { color: unset !important; }',
      'html,body{background:#07090f!important;margin:0!important;padding:0!important;}',
      '#pb-root{min-height:100vh;background:#07090f;}',
      '#pb-root *{box-sizing:border-box;}',
      '@keyframes pbSpin{to{transform:rotate(360deg)}}',
      '.pb-spinner{width:28px;height:28px;border:3px solid rgba(255,255,255,0.08);border-top-color:#3b82f6;border-radius:50%;animation:pbSpin 0.7s linear infinite;margin:40px auto;}',

// Override light-theme.css completely
      '#pb-root, #pb-root *, #pb-root div, #pb-root span, #pb-root p, #pb-root label, #pb-root button, #pb-root a { color: unset; }',
      '[data-theme="light"] #pb-root div, [data-theme="light"] #pb-root span, [data-theme="light"] #pb-root p, [data-theme="light"] #pb-root label { color: white !important; }',

      // Agent card
      '.pb-agent-card{background:linear-gradient(135deg,#111827,#1a2235);border:1px solid rgba(255,255,255,0.07);border-radius:20px;padding:24px 20px 20px;margin-bottom:14px;position:relative;overflow:hidden;}',
      '.pb-agent-card::before{content:"";position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#3b82f6,#8b5cf6,#06b6d4);}',
      '.pb-agent-top{display:flex;gap:16px;align-items:flex-start;}',
      '.pb-avatar-wrap{position:relative;flex-shrink:0;}',
      '.pb-avatar{width:72px;height:72px;border-radius:50%;object-fit:cover;border:2px solid rgba(59,130,246,0.5);}',
      '.pb-avatar-init{width:72px;height:72px;border-radius:50%;background:linear-gradient(135deg,#3b82f6,#8b5cf6);display:flex;align-items:center;justify-content:center;font-size:26px;font-weight:800;color:#fff!important;border:2px solid rgba(59,130,246,0.5);}',
      '.pb-online-dot{position:absolute;bottom:2px;right:2px;width:14px;height:14px;border-radius:50%;background:#22c55e;border:2px solid #111827;}',
      '.pb-agent-name{font-size:20px;font-weight:800;color:#f1f5f9!important;line-height:1.2;margin-bottom:4px;}',
      '.pb-event-badge{display:inline-flex;align-items:center;gap:5px;font-size:12px;color:#60a5fa!important;font-weight:700;margin-bottom:10px;}',
      '.pb-meta-row{display:flex;flex-wrap:wrap;gap:7px;}',
      '.pb-chip{display:flex;align-items:center;gap:4px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:20px;padding:3px 10px;font-size:12px;color:#94a3b8!important;}',
      '.pb-bio-section{padding-top:16px;margin-top:16px;border-top:1px solid rgba(255,255,255,0.06);}',
      '.pb-bio-label{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:1px;color:#64748b!important;margin-bottom:6px;}',
      '.pb-bio-text{font-size:13.5px;color:#94a3b8!important;line-height:1.75;margin-bottom:14px;background:transparent!important;white-space:pre-line;}',      '.pb-socials{display:flex;gap:8px;flex-wrap:wrap;}',
      '.pb-social-a{display:flex;align-items:center;gap:5px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:8px;padding:6px 12px;font-size:12px;color:#94a3b8!important;text-decoration:none;transition:all 0.2s;font-weight:500;}',
      '.pb-social-a:hover{background:rgba(59,130,246,0.15);border-color:rgba(59,130,246,0.4);color:#93c5fd!important;}',

      // Steps
      '.pb-steps-row{display:flex;align-items:center;justify-content:center;gap:0;margin-bottom:16px;}',
      '.pb-step-item{display:flex;flex-direction:column;align-items:center;gap:4px;}',
      '.pb-step-dot{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;border:2px solid rgba(255,255,255,0.15);background:rgba(255,255,255,0.06);color:#94a3b8!important;transition:all 0.3s;}',
      '.pb-step-dot.active{background:#3b82f6;border-color:#3b82f6;color:#fff!important;box-shadow:0 0 16px rgba(59,130,246,0.4);}',
      '.pb-step-dot.done{background:#22c55e;border-color:#22c55e;color:#fff!important;}',
      '.pb-step-lbl{font-size:10px;color:#64748b!important;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;}',
      '.pb-step-lbl.active{color:#3b82f6!important;}',
      '.pb-step-line{width:36px;height:2px;background:rgba(255,255,255,0.07);margin:0 4px;margin-bottom:18px;transition:background 0.3s;}',
      '.pb-step-line.done{background:#22c55e;}',

      // Card
      '.pb-card{background:#111827;border:1px solid rgba(255,255,255,0.07);border-radius:20px;padding:22px 18px;margin-bottom:12px;}',
      '.pb-card-title{font-size:16px;font-weight:700;color:#f1f5f9!important;margin-bottom:16px;display:flex;align-items:center;gap:8px;}',

      // Date/slot grid
      '.pb-grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;}',
      '.pb-date-btn{background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:12px 6px;cursor:pointer;text-align:center;transition:all 0.2s;color:#e2e8f0!important;}',
      '.pb-date-btn:hover{background:rgba(59,130,246,0.1);border-color:rgba(59,130,246,0.3);}',
      '.pb-date-btn.sel{background:rgba(59,130,246,0.18);border-color:#3b82f6;box-shadow:0 0 12px rgba(59,130,246,0.2);}',
      '.pb-date-day{font-size:10px;color:#94a3b8!important;font-weight:700;text-transform:uppercase;margin-bottom:2px;}',
      '.pb-date-num{font-size:20px;font-weight:800;color:#f1f5f9!important;line-height:1;margin-bottom:2px;}',
      '.pb-date-mon{font-size:10px;color:#94a3b8!important;}',
      '.pb-date-btn.sel .pb-date-day,.pb-date-btn.sel .pb-date-mon{color:#93c5fd!important;}',
      '.pb-date-btn.sel .pb-date-num{color:#60a5fa!important;}',
      '.pb-slot-btn{background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:10px;padding:12px 4px;cursor:pointer;text-align:center;color:#e2e8f0!important;font-size:14px;font-weight:700;transition:all 0.2s;}',
      '.pb-slot-btn:hover{background:rgba(59,130,246,0.1);border-color:rgba(59,130,246,0.3);}',
      '.pb-slot-btn.sel{background:rgba(59,130,246,0.18);border-color:#3b82f6;color:#93c5fd!important;box-shadow:0 0 10px rgba(59,130,246,0.2);}',

      // Form
      '.pb-lbl{display:block;font-size:11px;font-weight:800;color:#64748b!important;margin-bottom:6px;text-transform:uppercase;letter-spacing:0.5px;}',
      '.pb-input{width:100%;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.09);border-radius:10px;padding:12px 14px;color:#e2e8f0!important;font-size:14px;outline:none;transition:border-color 0.2s;}',
      '.pb-input:focus{border-color:#3b82f6;background:rgba(59,130,246,0.05);}',
      '.pb-input::placeholder{color:#475569!important;}',
      'textarea.pb-input{resize:vertical;min-height:80px;}',
      'select.pb-input option{background:#1e293b;color:#e2e8f0!important;}',

      // Summary
      '.pb-summary{background:rgba(59,130,246,0.06);border:1px solid rgba(59,130,246,0.14);border-radius:12px;padding:14px;margin-bottom:16px;}',
      '.pb-sum-row{display:flex;justify-content:space-between;align-items:center;padding:5px 0;}',
      '.pb-sum-row:not(:last-child){border-bottom:1px solid rgba(255,255,255,0.05);}',
      '.pb-sum-lbl{font-size:12px;color:#64748b!important;}',
      '.pb-sum-val{font-size:13px;color:#e2e8f0!important;font-weight:700;}',

      // Buttons
      '.pb-btn-primary{width:100%;background:linear-gradient(135deg,#3b82f6,#6366f1);border:none;border-radius:12px;padding:14px;color:#fff!important;font-size:15px;font-weight:700;cursor:pointer;transition:all 0.2s;box-shadow:0 4px 20px rgba(59,130,246,0.28);}',
      '.pb-btn-primary:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 6px 24px rgba(59,130,246,0.4);}',
      '.pb-btn-primary:disabled{opacity:0.5;cursor:not-allowed;}',
      '.pb-btn-ghost{width:100%;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.09);border-radius:12px;padding:12px;color:#94a3b8!important;font-size:14px;font-weight:600;cursor:pointer;transition:all 0.2s;margin-top:8px;}',
      '.pb-btn-ghost:hover{background:rgba(255,255,255,0.07);color:#e2e8f0!important;}',
      '.pb-btn-link{background:none;border:none;color:#3b82f6!important;cursor:pointer;font-size:13px;font-weight:600;padding:0;margin-bottom:12px;display:inline-flex;align-items:center;gap:4px;}',

      // Lang
      '.pb-lang-btn{display:flex;align-items:center;gap:6px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);color:#94a3b8!important;padding:7px 14px;border-radius:20px;cursor:pointer;font-size:13px;font-weight:500;margin-bottom:18px;transition:all 0.2s;}',
      '.pb-lang-btn:hover{background:rgba(255,255,255,0.09);color:#e2e8f0!important;}',

      // Success
      '.pb-success-icon{font-size:64px;display:block;margin-bottom:16px;text-align:center;}',
      '.pb-success-title{font-size:22px;font-weight:800;color:#f1f5f9!important;text-align:center;margin-bottom:8px;}',
      '.pb-success-sub{font-size:14px;color:#64748b!important;text-align:center;margin-bottom:24px;line-height:1.6;}',

      // Misc
      '.pb-empty{text-align:center;color:#64748b!important;font-size:14px;padding:28px 0;}',
      '.pb-brand{text-align:center;margin-top:24px;}',
      '.pb-brand a{font-size:12px;color:#374151!important;text-decoration:none;}',
      '.pb-brand a:hover{color:#3b82f6!important;}',

      '@media(max-width:360px){.pb-grid3{grid-template-columns:repeat(2,1fr)}}'
    ].join('\n');
    document.head.appendChild(s);
    return function() { var el = document.getElementById('pb-dark-override'); if (el) el.remove(); };
  }, []);
  
  // ─── Fetch event info ─────────────────────────────────────────────────────
  useEffect(function() {
    fetch(API_BASE + '/' + agentSlug + '/' + eventSlug)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.success) {
          setEventData(data.data.event);
          setAgentData(data.data.agent);
          var cm = data.data.event.connection_methods;
          if (cm && cm.length === 1) setConnMethod(cm[0]);
        } else {
          setError(data.message || 'الحدث غير موجود');
        }
        setLoading(false);
      })
      .catch(function() { setError('فشل في التحميل'); setLoading(false); });
  }, [agentSlug, eventSlug]);

  // ─── Fetch slots ──────────────────────────────────────────────────────────
  function fetchSlots(date) {
    setSlotsLoading(true);
    setSelectedSlot(null);
    fetch(API_BASE + '/' + agentSlug + '/' + eventSlug + '/slots?date=' + date)
      .then(function(r) { return r.json(); })
      .then(function(data) { if (data.success) setSlots(data.data); setSlotsLoading(false); })
      .catch(function() { setSlots([]); setSlotsLoading(false); });
  }

  // ─── Submit ───────────────────────────────────────────────────────────────
  function handleSubmit() {
    if (!custName || !custPhone) { alert(isRTL ? 'يرجى ملء الاسم ورقم الهاتف' : 'Please fill name and phone'); return; }
    setSubmitting(true);
    fetch(API_BASE + '/' + agentSlug + '/' + eventSlug, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_name: custName, phone: custPhone, customer_email: custEmail,
        connection_method: connMethod, meeting_reason: meetReason,
        booking_date: selectedDate, start_time: selectedSlot.start_time
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.success) {
        setBookingResult(Object.assign({}, data.data, { booking_date: selectedDate, start_time: selectedSlot.start_time }));
        setStep(4);
      } else alert(data.message || 'فشل الحجز');
      setSubmitting(false);
    })
    .catch(function() { alert('فشل'); setSubmitting(false); });
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────
  function formatTime(t) {
    if (!t) return '';
    var p = t.split(':'); var h = parseInt(p[0]); var m = p[1];
    return (h % 12 || 12) + ':' + m + ' ' + (h >= 12 ? 'PM' : 'AM');
  }

  function getNextDays() {
    var days = []; var today = new Date(); var availDays = [];
    try {
      if (agentData && agentData.availability_days) {
        availDays = typeof agentData.availability_days === 'string'
          ? JSON.parse(agentData.availability_days) : agentData.availability_days;
      }
    } catch(e) { availDays = []; }
    var dayMap = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
    for (var i = 0; i < 30; i++) {
      var d = new Date(today); d.setDate(d.getDate() + i);
      var dn = dayMap[d.getDay()];
      if (availDays.length === 0 || availDays.indexOf(dn) >= 0) {
        days.push({
          date: d.toISOString().split('T')[0],
          day: isRTL ? d.toLocaleDateString('ar-EG', { weekday: 'short' }) : d.toLocaleDateString('en-US', { weekday: 'short' }),
          num: d.getDate(),
          mon: isRTL ? d.toLocaleDateString('ar-EG', { month: 'short' }) : d.toLocaleDateString('en-US', { month: 'short' })
        });
      }
    }
    return days;
  }

  function getInitials(name) {
    if (!name) return '?';
    return name.trim().split(' ').map(function(n) { return n[0]; }).join('').slice(0, 2).toUpperCase();
  }

  function getSocials() {
    if (!agentData) return [];
    var links = [];
    if (agentData.linkedin_url)  links.push({ url: agentData.linkedin_url,  label: 'LinkedIn',   icon: '🔗' });
    if (agentData.twitter_url)   links.push({ url: agentData.twitter_url,   label: 'Twitter / X', icon: '✖️' });
    if (agentData.instagram_url) links.push({ url: agentData.instagram_url, label: 'Instagram',  icon: '📸' });
    if (agentData.facebook_url)  links.push({ url: agentData.facebook_url,  label: 'Facebook',   icon: '👤' });
    if (agentData.youtube_url)   links.push({ url: agentData.youtube_url,   label: 'YouTube',    icon: '▶️' });
    return links;
  }

  var fontFamily = isRTL ? "'Cairo', sans-serif" : "'Plus Jakarta Sans', sans-serif";
  var dir = isRTL ? 'rtl' : 'ltr';
  var PAGE  = { minHeight: '100vh', background: '#07090f', padding: '16px', fontFamily: fontFamily, direction: dir };
  var INNER = { maxWidth: '480px', margin: '0 auto', paddingBottom: '40px' };
  var stepLabels = isRTL ? ['التاريخ', 'الوقت', 'التأكيد'] : ['Date', 'Time', 'Confirm'];

  // ─── Loading ──────────────────────────────────────────────────────────────
  if (loading) {
    return React.createElement('div', { id: 'pb-root', style: PAGE },
      React.createElement('div', { style: INNER }, React.createElement('div', { className: 'pb-spinner' }))
    );
  }

  // ─── Error ────────────────────────────────────────────────────────────────
  if (errorMsg) {
    return React.createElement('div', { id: 'pb-root', style: PAGE },
      React.createElement('div', { style: INNER },
        React.createElement('div', { className: 'pb-card', style: { textAlign: 'center', padding: '40px 20px' } },
          React.createElement('div', { style: { fontSize: '48px', marginBottom: '16px' } }, '😕'),
          React.createElement('div', { style: { color: '#94a3b8', fontSize: '16px' } }, errorMsg)
        )
      )
    );
  }

  if (!eventData || !agentData) {
    return React.createElement('div', { id: 'pb-root', style: PAGE },
      React.createElement('div', { style: INNER }, React.createElement('div', { className: 'pb-empty' }, '...'))
    );
  }

  // ─── Success ──────────────────────────────────────────────────────────────
  if (step === 4 && bookingResult) {
    return React.createElement('div', { id: 'pb-root', style: PAGE },
      React.createElement('div', { style: INNER },
        React.createElement('div', { className: 'pb-card' },
          React.createElement('span', { className: 'pb-success-icon' }, '🎉'),
          React.createElement('div', { className: 'pb-success-title' }, isRTL ? 'تم تأكيد الحجز!' : 'Booking Confirmed!'),
          React.createElement('div', { className: 'pb-success-sub' }, isRTL ? 'ستصلك رسالة تأكيد على الواتساب قريباً.' : 'You will receive a WhatsApp confirmation shortly.'),
          React.createElement('div', { className: 'pb-summary' },
            React.createElement('div', { className: 'pb-sum-row' },
              React.createElement('span', { className: 'pb-sum-lbl' }, isRTL ? 'التاريخ' : 'Date'),
              React.createElement('span', { className: 'pb-sum-val' }, bookingResult.booking_date || '')
            ),
            React.createElement('div', { className: 'pb-sum-row' },
              React.createElement('span', { className: 'pb-sum-lbl' }, isRTL ? 'الوقت' : 'Time'),
              React.createElement('span', { className: 'pb-sum-val' }, formatTime(bookingResult.start_time || ''))
            ),
            React.createElement('div', { className: 'pb-sum-row' },
              React.createElement('span', { className: 'pb-sum-lbl' }, isRTL ? 'المدة' : 'Duration'),
              React.createElement('span', { className: 'pb-sum-val' },
                (bookingResult.duration || eventData.duration_minutes) + (isRTL ? ' دقيقة' : ' min')
              )
            ),
            React.createElement('div', { className: 'pb-sum-row' },
              React.createElement('span', { className: 'pb-sum-lbl' }, isRTL ? 'مع' : 'With'),
              React.createElement('span', { className: 'pb-sum-val' }, agentData.full_name || '')
            )
          )
        ),
        React.createElement('div', { className: 'pb-brand' },
          React.createElement('a', { href: 'https://matix.one', target: '_blank', rel: 'noreferrer' }, 'Powered by MatixERP ✦')
        )
      )
    );
  }

  var connMethods = eventData.connection_methods || [];
  var socials = getSocials();

  // ─── Main Render ──────────────────────────────────────────────────────────
  return React.createElement('div', { id: 'pb-root', style: PAGE },
    React.createElement('div', { style: INNER },

      // Lang toggle
      React.createElement('button', {
        className: 'pb-lang-btn', style: { fontFamily: fontFamily },
        onClick: function() { setLang(isRTL ? 'en' : 'ar'); }
      }, '🌐 ', isRTL ? 'English' : 'عربي'),

      // ── Agent Profile Card ──────────────────────────────────────────────
      React.createElement('div', { className: 'pb-agent-card' },

        React.createElement('div', { className: 'pb-agent-top' },

          // Avatar
          React.createElement('div', { className: 'pb-avatar-wrap' },
            agentData.profile_picture
              ? React.createElement('img', { src: agentData.profile_picture, alt: agentData.full_name, className: 'pb-avatar' })
              : React.createElement('div', { className: 'pb-avatar-init' }, getInitials(agentData.full_name)),
            React.createElement('div', { className: 'pb-online-dot' })
          ),

          // Info
          React.createElement('div', { style: { flex: 1, minWidth: 0 } },
            React.createElement('div', { className: 'pb-agent-name' }, agentData.full_name),
            React.createElement('div', { className: 'pb-event-badge' }, '📅 ', eventData.title),
            React.createElement('div', { className: 'pb-meta-row' },
              eventData.duration_minutes
                ? React.createElement('div', { className: 'pb-chip' }, '⏱ ', eventData.duration_minutes, ' ', isRTL ? 'دقيقة' : 'min')
                : null,
              agentData.timezone
                ? React.createElement('div', { className: 'pb-chip' }, '🕐 ', agentData.timezone.replace(/_/g, ' '))
                : null,
              connMethods.length === 1 && methodIcons[connMethods[0]]
                ? React.createElement('div', { className: 'pb-chip' }, methodIcons[connMethods[0]])
                : null
            )
          )
        ),

        // Bio + Socials (only if data exists)
        (agentData.bio || socials.length > 0)
          ? React.createElement('div', { className: 'pb-bio-section' },
              agentData.bio ? React.createElement('div', null,
                React.createElement('div', { className: 'pb-bio-label' }, isRTL ? 'نبذة عني' : 'About Me'),
                React.createElement('div', { className: 'pb-bio-text', style: { whiteSpace: 'pre-line' } }, agentData.bio)
              ) : null,
              socials.length > 0 ? React.createElement('div', { className: 'pb-socials' },
                socials.map(function(sl, i) {
                  return React.createElement('a', {
                    key: i, href: sl.url, target: '_blank', rel: 'noreferrer', className: 'pb-social-a'
                  }, sl.icon, ' ', sl.label);
                })
              ) : null
            )
          : null
      ),

      // ── Step Indicator ─────────────────────────────────────────────────
      React.createElement('div', { className: 'pb-steps-row' },
        stepLabels.map(function(lbl, i) {
          var num = i + 1;
          var isActive = step === num;
          var isDone = step > num;
          var dotCls = 'pb-step-dot' + (isActive ? ' active' : isDone ? ' done' : '');
          var lblCls = 'pb-step-lbl' + (isActive ? ' active' : '');
          return React.createElement(React.Fragment, { key: i },
            i > 0 ? React.createElement('div', { className: 'pb-step-line' + (step > i ? ' done' : '') }) : null,
            React.createElement('div', { className: 'pb-step-item' },
              React.createElement('div', { className: dotCls }, isDone ? '✓' : num),
              React.createElement('div', { className: lblCls }, lbl)
            )
          );
        })
      ),

      // ── Step 1: Date ───────────────────────────────────────────────────
      step === 1 ? React.createElement('div', { className: 'pb-card' },
        React.createElement('div', { className: 'pb-card-title' }, '📅 ', isRTL ? 'اختر التاريخ' : 'Choose a Date'),
        React.createElement('div', { className: 'pb-grid3' },
          getNextDays().map(function(day) {
            var isSel = selectedDate === day.date;
            return React.createElement('button', {
              key: day.date,
              className: 'pb-date-btn' + (isSel ? ' sel' : ''),
              onClick: function() { setSelectedDate(day.date); fetchSlots(day.date); setStep(2); }
            },
              React.createElement('div', { className: 'pb-date-day' }, day.day),
              React.createElement('div', { className: 'pb-date-num' }, day.num),
              React.createElement('div', { className: 'pb-date-mon' }, day.mon)
            );
          })
        )
      ) : null,

      // ── Step 2: Time ───────────────────────────────────────────────────
      step === 2 ? React.createElement('div', { className: 'pb-card' },
        React.createElement('div', { className: 'pb-card-title' }, '⏰ ', isRTL ? 'اختر الوقت' : 'Choose a Time'),
        React.createElement('div', { style: { fontSize: '13px', color: '#4b5563', marginBottom: '14px' } }, '📅 ', selectedDate),
        React.createElement('button', {
          className: 'pb-btn-link', onClick: function() { setStep(1); }
        }, isRTL ? '→ تغيير التاريخ' : '← Change date'),
        slotsLoading
          ? React.createElement('div', { className: 'pb-spinner' })
          : slots.length === 0
            ? React.createElement('div', { className: 'pb-empty' }, isRTL ? 'لا توجد مواعيد متاحة في هذا اليوم' : 'No available slots for this day')
            : React.createElement('div', { className: 'pb-grid3' },
                slots.map(function(slot, i) {
                  var isSel = selectedSlot === slot;
                  return React.createElement('button', {
                    key: i,
                    className: 'pb-slot-btn' + (isSel ? ' sel' : ''),
                    onClick: function() { setSelectedSlot(slot); setStep(3); }
                  }, formatTime(slot.start_time));
                })
              )
      ) : null,

      // ── Step 3: Form ───────────────────────────────────────────────────
      step === 3 ? React.createElement('div', { className: 'pb-card' },
        React.createElement('div', { className: 'pb-card-title' }, '📝 ', isRTL ? 'تأكيد الحجز' : 'Confirm Booking'),

        // Booking summary
        React.createElement('div', { className: 'pb-summary' },
          React.createElement('div', { className: 'pb-sum-row' },
            React.createElement('span', { className: 'pb-sum-lbl' }, isRTL ? 'التاريخ' : 'Date'),
            React.createElement('span', { className: 'pb-sum-val' }, selectedDate)
          ),
          React.createElement('div', { className: 'pb-sum-row' },
            React.createElement('span', { className: 'pb-sum-lbl' }, isRTL ? 'الوقت' : 'Time'),
            React.createElement('span', { className: 'pb-sum-val' },
              formatTime(selectedSlot ? selectedSlot.start_time : '') +
              ' → ' +
              formatTime(selectedSlot ? selectedSlot.end_time : '')
            )
          ),
          React.createElement('div', { className: 'pb-sum-row' },
            React.createElement('span', { className: 'pb-sum-lbl' }, isRTL ? 'المدة' : 'Duration'),
            React.createElement('span', { className: 'pb-sum-val' }, eventData.duration_minutes + (isRTL ? ' دقيقة' : ' min'))
          )
        ),

        // Form fields
        React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '12px' } },

          React.createElement('div', null,
            React.createElement('label', { className: 'pb-lbl', style: { fontFamily: fontFamily } }, isRTL ? 'الاسم الكامل *' : 'Full Name *'),
            React.createElement('input', {
              type: 'text', value: custName, className: 'pb-input',
              style: { fontFamily: fontFamily, direction: dir },
              onChange: function(e) { setCustName(e.target.value); },
              placeholder: isRTL ? 'أدخل اسمك الكامل' : 'Enter your full name'
            })
          ),

          React.createElement('div', null,
            React.createElement('label', { className: 'pb-lbl', style: { fontFamily: fontFamily } }, isRTL ? 'رقم الواتساب *' : 'WhatsApp Number *'),
            React.createElement('input', {
              type: 'tel', value: custPhone, className: 'pb-input',
              style: { fontFamily: fontFamily, direction: 'ltr' },
              onChange: function(e) { setCustPhone(e.target.value); },
              placeholder: '+201012345678'
            })
          ),

          React.createElement('div', null,
            React.createElement('label', { className: 'pb-lbl', style: { fontFamily: fontFamily } }, isRTL ? 'البريد الإلكتروني (اختياري)' : 'Email (optional)'),
            React.createElement('input', {
              type: 'email', value: custEmail, className: 'pb-input',
              style: { fontFamily: fontFamily, direction: 'ltr' },
              onChange: function(e) { setCustEmail(e.target.value); },
              placeholder: 'email@example.com'
            })
          ),

          connMethods.length > 1 ? React.createElement('div', null,
            React.createElement('label', { className: 'pb-lbl', style: { fontFamily: fontFamily } }, isRTL ? 'وسيلة الاجتماع' : 'Meeting Method'),
            React.createElement('select', {
              value: connMethod, className: 'pb-input',
              style: { fontFamily: fontFamily, direction: dir },
              onChange: function(e) { setConnMethod(e.target.value); }
            },
              React.createElement('option', { value: '' }, isRTL ? 'اختر...' : 'Select...'),
              connMethods.map(function(m) { return React.createElement('option', { key: m, value: m }, methodIcons[m] || m); })
            )
          ) : null,

          React.createElement('div', null,
            React.createElement('label', { className: 'pb-lbl', style: { fontFamily: fontFamily } }, isRTL ? 'ملاحظات (اختياري)' : 'Notes (optional)'),
            React.createElement('textarea', {
              value: meetReason, rows: 3, className: 'pb-input',
              style: { fontFamily: fontFamily, direction: dir },
              onChange: function(e) { setMeetReason(e.target.value); },
              placeholder: isRTL ? 'ما الذي تود مناقشته؟' : 'What would you like to discuss?'
            })
          ),

          React.createElement('button', {
            onClick: handleSubmit, disabled: submitting,
            className: 'pb-btn-primary', style: { fontFamily: fontFamily }
          }, submitting ? (isRTL ? 'جاري الحجز...' : 'Booking...') : (isRTL ? '✅ تأكيد الحجز' : '✅ Confirm Booking')),

          React.createElement('button', {
            onClick: function() { setStep(2); },
            className: 'pb-btn-ghost', style: { fontFamily: fontFamily }
          }, isRTL ? '← رجوع' : '← Back')
        )
      ) : null,

      // Branding
      React.createElement('div', { className: 'pb-brand' },
        React.createElement('a', { href: 'https://matix.one', target: '_blank', rel: 'noreferrer' }, 'Powered by MatixERP ✦')
      )

    )
  );
}

export default PublicBooking;